module.exports = __webpack_public_path__ + "static/media/title.db8c8114.svg";